import { render, staticRenderFns } from "./income-generalization.vue?vue&type=template&id=37fff9e7&scoped=true&"
import script from "./income-generalization.vue?vue&type=script&lang=js&"
export * from "./income-generalization.vue?vue&type=script&lang=js&"
import style0 from "./income-generalization.vue?vue&type=style&index=0&id=37fff9e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fff9e7",
  null
  
)

export default component.exports